import { render, staticRenderFns } from "./DownloadInvoicesAndCreateOrders.vue?vue&type=template&id=baf922ce&"
import script from "./DownloadInvoicesAndCreateOrders.vue?vue&type=script&lang=js&"
export * from "./DownloadInvoicesAndCreateOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports